export enum SharedMediaTypeEnum {
  Image = "image",
  Video = "video",
  Audio = "voice",
}
